import gql from "graphql-tag"
import wellnessMediaArticle from "../fragments/WellnessMediaArticle"

const fragment = gql`
  fragment wellnessLane on WellnessLane {
    id
    uuid
    title
    mediaCardCount
    mediaList {
      ...wellnessMediaArticle
    }
  }
  ${wellnessMediaArticle}
`

export const toString = fragment.loc.source.body

export default fragment
